<template>
  <div v-if="locales.length > 1" class="flex space-x-2 items-center">
    <bc-button
      v-for="locale in locales" :key="locale.short"
      variant="small"
      :class="{ 'bg-gray-900 text-white' : active === locale.short }"
      @click="$store.commit('locale/SET_LOCALE', locale.short)"
      :aria-label="$t('Switch Language')"
    >
      {{ locale.long }}
    </bc-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LocaleToggler',
  data () {
    return {
      locales: window.BoldCMS.locales
    }
  },
  beforeMount() {
    this.$store.dispatch('locale/initLocale')
  },
  computed: {
    ...mapGetters({ active: 'locale/getLocale' })
  }
}
</script>
